function validate(binding) {
  if (typeof binding.value !== 'function') {
    console.warn('[v-clickaway] provided expression is not a function.')
    return false
  }

  return true
}

const clickaway = {
  beforeMount(el, binding) {
    if (!validate(binding)) return

    function handler(e) {
      const elements = e.path || (e.composedPath && e.composedPath())

      if (elements && elements.length > 0) {
        elements.unshift(e.target)
      }

      if (!el.contains(e.target)) {
        el.__clickaway__.callback(e)
      }
    }

    el.__clickaway__ = {
      handler: handler,
      callback: binding.value,
    }

    setTimeout(() => {
      const clickHandler = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click'

      document.addEventListener(clickHandler, handler, true)
    }, 0)
  },
  updated(el, binding) {
    if (validate(binding)) {
      el.__clickaway__.callback = binding.value
    }
  },
  unmounted(el) {
    const clickHandler = 'ontouchstart' in document.documentElement ? 'touchstart' : 'click';

    if (el.__clickaway__) {
      document.removeEventListener(clickHandler, el.__clickaway__.handler, true)
      delete el.__clickaway__
    }
  },
}

export default clickaway
